export default function StatusPage({
  title,
  description,
  code,
  actionButton,
}: {
  title: string;
  description: string;
  code: string;
  actionButton?: any;
}) {
  return (
    <section className="bg-white dark:bg-zinc-900 ">
      <div className="container mx-auto min-h-screen px-6 py-12 text-center lg:flex lg:items-center">
        <div className="w-full">
          <p className="text-lg font-normal text-gray-600 dark:text-zinc-400">
            {code} error
          </p>

          <h1 className="relative mt-6 inline-block text-3xl font-semibold text-gray-800 dark:text-zinc-200 md:text-4xl">
            <span className="relative text-white">
              <span className="relative z-10">{title}</span>
              <span className=" absolute left-0 z-0 mx-auto h-12 w-full -rotate-3 bg-gray-500/50 dark:bg-zinc-500/50 rtl:right-0"></span>
              <span className=" absolute left-0 z-0 mx-auto h-12 w-full rotate-2 bg-black/80 rtl:right-0"></span>
            </span>
          </h1>

          <p className="mt-8 text-lg text-gray-500 dark:text-gray-400">
            {description}
          </p>

          {actionButton && (
            <div className="mt-6 flex justify-center">{actionButton}</div>
          )}
        </div>
      </div>
    </section>
  );
}
